import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction, Box } from "@mui/material";
import { Modal } from "react-bootstrap";

import Supplier_Products from "./Supplier_Products";
import Supplier_order from "./Supplier_order";
import Supplier_Profile_Tab from "./Supplier_Profile";

import Pan from "../../assets/svg/PenEtat.svg";
import phoneIcon from "../../assets/svg/Phone.svg";
import emailIcon from "../../assets/svg/Email1.svg";
import Websiteink from "../../assets/svg/Websiteink.svg";
import map from "../../assets/svg/map.svg";
import CompanyName from "../../assets/svg/Logo.svg";
import UserIcon from "../../assets/svg/user 1.svg";
import defaoult from "../../assets/svg/defultImage.svg";
import def from "../../assets/svg/defultImage.svg";
import { useSelector } from "react-redux";
import {
  DeleteOutline,
  Edit,
  Email,
  InsertLink,
  Link,
  LocationOnOutlined,
  Person,
  Phone,
} from "@mui/icons-material";

const SupplierProfile = () => {
  const { user } = useSelector((state) => state.auth);
  const token = user?.token;
  const { id } = useParams();
  const navigate = useNavigate();

  const [value, setValue] = useState(0);
  const [show, setShow] = useState(false);
  const [provider, setProvider] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const Cloes = () => setShow(false);
  const submitTheDelete = () => setShow(false);
  const open = () => setShow(true);

  useEffect(() => {
    const fetchProvider = async () => {
      try {
        const res = await axios.get(
          `https://estbn.com/EstbnNew/public/api/portal/providers/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setProvider(res.data.data.provider);
      } catch (err) {
        console.error("Failed to fetch provider:", err);
      }
    };

    fetchProvider();
  }, []);

  // if (isLoading) {
  //   return <div>Loading supplier profile...</div>;
  // }

  // if (error) {
  //   return <div style={{ color: 'red', textAlign: 'center' }}>Error: {error}</div>;
  // }

  //  if (!provider && !isLoading && !error) {

  //      return <div>Provider data not available.</div>;
  //  }

  return (
    <>
      <Modal show={show} onHide={Cloes}>
        <Modal.Header>
          <Modal.Title className="titleModel_sus-delet">
            Suspend Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="deleteOrderMasege_sus">
            Are you want to suspend this supplier
          </div>
          <div className="deleteOrderMasege_sus-span">
            “ {provider?.name} “?
          </div>
          <div className="OrdersTable-footer">
            <button onClick={Cloes} className="ordersCancelTable">
              Cancel
            </button>
            <button
              onClick={submitTheDelete}
              className=" deletOrderbutton_sus "
            >
              Suspend
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <div className="m-4">
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-12 min-vh-100">
            <div className="my-4">
              <h5 className="m  -0">Supplier Profile</h5>
            </div>
            <div className="my-5 min-vh-100">
              <div className="supplier_img px-3">
                <div className="supplier_imgHulder">
                  <img
                    src={
                      provider.logo_url
                        ? `https://estbn.com/EstbnNew/public${provider?.logo_url}`
                        : def
                    }
                    alt="Company Logo"
                    className=" img-fluid w-50"
                  />
                </div>{" "}
                <div
                  onClick={() =>
                    navigate(`/stock/vendors/supplier/${provider.id}`)
                  }
                  className="editeTheSupplier_img cursor"
                >
                  <img src={Pan} className=" w-75" alt="edit icon" />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div className="">
                  <h6 className="fw-bold">{provider?.name}</h6>

                  <p>Joined recently</p>
                </div>
                <div className="d-flex align-items-center gap-2 my-1">
                  <div>
                    <Email color="action" />
                  </div>
                  <div>
                    <Phone color="action" />
                  </div>
                </div>
              </div>
              <div className="">
                <h6 className="fw-bold">Company Info</h6>
                <div className="my-2">
                  <div className="d-flex align-items-center gap-2">
                    <Person />
                    <h6 className="m-0">{provider?.name}</h6>
                  </div>

                  {provider?.website && (
                    <div className="">
                      <InsertLink />
                      <h6 className="m-0">{provider.website}</h6>
                    </div>
                  )}

                  {provider?.contacts?.map((contact, index) => (
                    <div
                      key={index}
                      className="my-2 d-flex align-items-center gap-2 "
                    >
                      <InsertLink />
                      <h6 className="m-0 hide-text-sm">{contact.info}</h6>
                    </div>
                  ))}
                  {(!provider?.contacts || provider.contacts.length === 0) && (
                    <div className="">No contact info available</div>
                  )}
                </div>
              </div>
              <div className="my-4">
                <h6 className="fw-bold">Services</h6>

                {provider?.services?.length > 0 ? (
                  provider.services.map((service, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2 my-2"
                    >
                      <img
                        style={{ width: "30px" }}
                        src={
                          service.image
                            ? `https://estbn.com/EstbnNew/public${service.image?.image_url}`
                            : defaoult
                        }
                        alt={service.name || "Service"}
                      />
                      {/* Use optional chaining (?.) */}
                      <div className="">{service?.name}</div>
                    </div>
                  ))
                ) : (
                  <div className="">No services available</div>
                )}
              </div>
              <div className="my-4">
                <h6 className="fw-bold">Main Branch</h6>

                {provider?.branches?.length > 0 ? (
                  provider.branches.map((branch, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2 my-1"
                    >
                      <LocationOnOutlined />

                      <p style={{ fontSize: "14px" }} className="m-0">
                        {branch?.address
                          ? `${branch.address?.address || ""}${
                              branch.address?.address &&
                              branch.address?.landmark
                                ? ", "
                                : ""
                            }${branch.address?.landmark || ""}`.trim() // Combine address and landmark carefully
                          : "No address provided"}
                      </p>
                    </div>
                  ))
                ) : (
                  <div className="">No branches available</div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-9 col-md-8 col-sm-12">
            <div className="p-3 ">
              <div className="d-flex justify-content-between align-items-center custom-card-sm">
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => setValue(newValue)}
                    sx={{
                      backgroundColor: "transparent",
                      height: "auto",
                      padding: 1,
                      borderRadius: {
                        sm: "10px",
                        xs: 0,
                      },
                      width: "100%",
                      flexDirection: {
                        xs: "column",
                        sm: "row",
                      },

                      alignItems: {
                        xs: "center",
                      },
                      ".MuiBottomNavigationAction-root": {
                        fontSize: "20px",
                        minWidth: 0,
                        padding: "8px 12px",
                        justifyContent: "center",
                        width: "100%",
                      },
                      ".Mui-selected": {
                        fontWeight: "bold",
                      },
                    }}
                  >
                    <BottomNavigationAction
                      className="BottomNavigationAction"
                      label="Profile"
                    />

                    <BottomNavigationAction
                      className="BottomNavigationAction"
                      label={`Orders`}
                    />

                    <BottomNavigationAction
                      className="BottomNavigationAction"
                      label={`Products`}
                    />
                  </BottomNavigation>
                </Box>
                <button
                  onClick={open}
                  className="btn btn-danger custom-btn-size-responsive "
                >
                  Suspend this supplier
                </button>
              </div>
              <div className="">
                {value === 0 ? (
                  <Supplier_Profile_Tab provider={provider} />
                ) : value === 1 ? (
                  <Supplier_order supplierId={provider.id} />
                ) : (
                  <Supplier_Products supplierId={provider.id} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="countainer_SupplierProfile">
        
        <div className="partone">
          <div className="supplier_pageTitle">Supplier Profile</div>
          <div className="supplier_Card">
            <div className="supplier_img">
              <div className="supplier_imgHulder">
                <img
                  src={
                    provider.logo_url
                      ? `https://estbn.com/EstbnNew/public${provider?.logo_url}`
                      : def
                  }
                  alt="Company Logo"
                />
              </div>
              <div onClick={()=> navigate(`/stock/vendors/supplier/${provider.id}`)} className="editeTheSupplier_img">
                <img src={Pan} alt="edit icon" />
              </div>
            </div>
            <div className="supplier_profileName">
              <div className="nameOfMemberProfile_sus">
            
                <div>{provider?.name}</div>
             
                <div>Joined recently</div>
              </div>
              <div className="supplier_profileName_edite_countainer">
                <img className="supplier_profileName_edite" src={phoneIcon} alt="phone icon" />
                <img className="supplier_profileName_edite" src={emailIcon} alt="email icon" />
              </div>
            </div>

            <div className="stuffprofileinfo_supplierProfile">
              <div className="agentInfo-Supp">Company Info</div>
              <div className="memberInfoItem">
                <img className="suppInfoItem_img" src={UserIcon} alt="user Icon" />
                <div className="memberInfotext_supplier">{provider?.name}</div>
              </div>

              {provider?.website && (
                <div className="memberInfoItem">
                  <img className="suppInfoItem_img" src={Websiteink} alt="link Icon" />
                  <div className="memberInfotext_supplier underlineLink">
                    {provider.website}
                  </div>
                </div>
              )}

              {provider?.contacts?.map((contact, index) => (
                <div key={index} className="memberInfoItem">
                  <img className="suppInfoItem_img" src={Websiteink} alt="Contact" />
                  <a
                    className="memberInfotext_supplier underlineLink"
                    href={contact.info}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {contact.info}
                  </a>
                </div>
              ))}
              {(!provider?.contacts || provider.contacts.length === 0) && (
                 <div className="memberInfotext_supplier">No contact info available</div>
              )}
            </div>

      
            <div className="stuffprofileinfo_supplierProfile">
              <div className="agentInfo-Supp">Services</div>
           
              {provider?.services?.length > 0 ? (
                provider.services.map((service, index) => (
                  <div key={index} className="memberInfoItem">
                   
                    <img
                      className="suppInfoItem_img"
                       src={service.image ? `https://estbn.com/EstbnNew/public${service.image?.image_url}` : defaoult}
                       alt={service.name || "Service"} 
                    />
                    <div className="memberInfotext_supplier">{service?.name}</div>
                  </div>
                ))
              ) : (
                <div className="memberInfotext_supplier">No services available</div>
              )}
            </div>

          
            <div className="stuffprofileinfo_supplierProfile">
              <div className="agentInfo-Supp">Main Branch</div>
              
              {provider?.branches?.length > 0 ? (
              
                provider.branches.map((branch, index) => (
                  <div key={index} className="memberInfoItem">
                    <img className="suppInfoItem_img" src={map} alt="Location Icon" />
                    
                    <div className="memberInfotext_supplier">
                      {branch?.address
                        ? `${branch.address?.address || ""}${branch.address?.address && branch.address?.landmark ? ", " : ""}${branch.address?.landmark || ""}`.trim() // Combine address and landmark carefully
                        : "No address provided"}
                    </div>
                  </div>
                ))
              ) : (
                <div className="memberInfotext_supplier">No branches available</div>
              )}
            </div>
          </div>
        </div>

    
        <div className="parttwo">
          <div className="titleMinu_suppler">
            <Box className="countainerOfSuppminu">
              <BottomNavigation
                showLabels
                value={value}
                onChange={(event, newValue) => setValue(newValue)}
                className="supplierMenuBar_bottom"
              >
                <BottomNavigationAction className="BottomNavigationAction" label="Profile" />
              
                <BottomNavigationAction className="BottomNavigationAction" label={`Orders`} />
               
                <BottomNavigationAction className="BottomNavigationAction" label={`Products`} />
              </BottomNavigation>
            </Box>
            <div onClick={open} className="titleMinu_suppler_Suspend">
              Suspend this supplier
            </div>
          </div>
          <div className="parttwoCuntintData">
           
            {value === 0 ? <Supplier_Profile_Tab provider={provider} /> : value === 1 ? <Supplier_order supplierId={provider.id} /> : <Supplier_Products supplierId={provider.id} />}
          </div>
        </div>
      </div> */}
    </>
  );
};

export default SupplierProfile;
